import api from './api';

// Test için mock data
const generateMockData = (days) => {
  const data = [];
  const endDate = new Date();
  
  for (let i = 0; i < days; i++) {
    const date = new Date();
    date.setDate(endDate.getDate() - i);
    
    data.push({
      keys: [date.toISOString().split('T')[0]],
      clicks: Math.floor(Math.random() * 100),
      impressions: Math.floor(Math.random() * 1000),
      ctr: Math.random() * 0.1,
      position: Math.random() * 10 + 1
    });
  }
  
  return { rows: data };
};

export const getSearchAnalytics = async (startDate, endDate) => {
  try {
    // Mock data dön
    const mockResponse = generateMockData(30);
    return mockResponse;
  } catch (error) {
    console.error('Search Console verisi alınırken hata:', error);
    throw error;
  }
};

export const getDailyVisitors = async (days = 30) => {
  try {
    const endDate = new Date();
    const startDate = new Date();
    startDate.setDate(startDate.getDate() - days);

    const response = await getSearchAnalytics(
      startDate.toISOString().split('T')[0],
      endDate.toISOString().split('T')[0]
    );

    if (!response?.rows?.length) {
      return [];
    }

    // Verileri dashboard için uygun formata dönüştür
    return response.rows.map(row => ({
      date: row.keys[0],
      clicks: row.clicks,
      impressions: row.impressions,
      ctr: parseFloat((row.ctr * 100).toFixed(2)),
      position: parseFloat(row.position.toFixed(2))
    }));
  } catch (error) {
    console.error('Günlük ziyaretçi verisi alınırken hata:', error);
    return [];
  }
};

export const getTopPages = async (days = 30) => {
  try {
    // Mock sayfalar
    const pages = [
      { url: '/anasayfa', clicks: 150, impressions: 1200, ctr: 0.125, position: 1.5 },
      { url: '/haberler', clicks: 120, impressions: 900, ctr: 0.133, position: 2.1 },
      { url: '/etkinlikler', clicks: 90, impressions: 800, ctr: 0.112, position: 3.2 },
      { url: '/iletisim', clicks: 75, impressions: 600, ctr: 0.125, position: 4.0 },
      { url: '/hakkimizda', clicks: 60, impressions: 500, ctr: 0.12, position: 4.5 }
    ];

    return pages.map(page => ({
      page: page.url,
      clicks: page.clicks,
      impressions: page.impressions,
      ctr: parseFloat((page.ctr * 100).toFixed(2)),
      position: parseFloat(page.position.toFixed(2))
    }));
  } catch (error) {
    console.error('En çok ziyaret edilen sayfalar alınırken hata:', error);
    return [];
  }
};
